import loadable from "@loadable/component";
import App from "App";
import DefaultLayout from "layouts/DefaultLayout";
import UserLayout from "layouts/UserLayout";
import { RouteObject } from "react-router-dom";

import { footerRouter } from "./FooterRoutes";
import { mainRouter } from "./MainRoutes";
import { userRouter } from "./UserRoutes";

const NotFoundPage = loadable(() => import("pages/NotFoundPage"));

const routesConfig: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        element: <DefaultLayout />,
        children: [
          mainRouter,
          footerRouter,
          {
            path: "*",
            element: <NotFoundPage />,
          },
        ],
      },

      {
        element: <UserLayout />,
        children: [userRouter],
      },
    ],
  },
];

export default routesConfig;
